/*
 * справочник версий для МНН (/для будущих справочников)
 * */

export class CurrentVersion {

  constructor() { }

  public id: number;
  public authorName: string;
  public createdAt: Date;
}



// WEBPACK FOOTER //
// ./src/app/modules/user/model/CurrentVersion.ts